import React from "react";
import { createGenerativeTriggers } from "../../../../../services/generative-triggers";
import { TriggerModal } from "../Form";

const TriggerCreate = (props) => {
    return <TriggerModal initValues={{ isActive: true }} onFinish={createGenerativeTriggers} {...props} />
}

export default TriggerCreate;
